export enum SpotlightRequirements {
  LENGTH = 'LENGTH',
  SIZE = 'SIZE',
  SOUND = 'SOUND',
  ATTATCHMENTS = 'ATTATCHMENTS',
  RIGHTS = 'RIGHTS',
  WATERMARK = 'WATERMARK',
}
